import { useEffect, useState } from 'react';
import { ToastOptions } from 'react-toastify';
import { DateTime } from 'luxon';
import { toast } from '../../util/toasts';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { Typography } from '../../components/typography/typography';
import useLocalStorage from 'use-local-storage';
import { usePaymentConfigApiV1 } from '../../clients/quipli-service/payment-config/payment-config-api-v1';

export const StripeCustomMigrationMessage = () => {
  const { getMultipleConfigurations } = useAPI();
  const { getStripeAccount } = usePaymentConfigApiV1();
  const [stripeMigrationDate, setStripeMigrationDate] = useState<string | undefined>();
  const [stripeAccountType, setStripeAccountType] = useState<string>();
  const [messageReceived, setMessageReceived] = useLocalStorage('stripeMigrationMessageReceived', '');

  useEffect(() => {
    Promise.all([getStripeAccount(), getMultipleConfigurations(['CONF_STRIPE_CUSTOM_CUTOFF_DATE'])]).then(
      ([stripeAccount, configurations]) => {
        setStripeAccountType(stripeAccount?.accountType);
        setStripeMigrationDate(
          configurations.find((c) => {
            return c.variable == 'CONF_STRIPE_CUSTOM_CUTOFF_DATE';
          })?.value,
        );
      },
    );
  }, []);

  const toastOptions: ToastOptions = {
    autoClose: false,
    theme: 'dark',
    position: 'top-center',
    toastId: 1,
  };
  const ToastMessage = () => (
    <div>
      <Typography type={'text-sm'}>Please upgrade your payments experience by {stripeMigrationDate}</Typography>
      <a
        className="underline text-quipli-white-50 hover:text-quipli-white-50 visited:text-gray-400"
        href="https://quiplihelp.zendesk.com/hc/en-us/articles/20711231359767-How-to-Migrate-or-Onboard-to-Stripe-Custom"
        target="_blank"
      >{` Click here for more information.`}</a>
    </div>
  );

  if (
    stripeAccountType == 'standard' &&
    stripeMigrationDate &&
    DateTime.fromISO(stripeMigrationDate) > DateTime.now() &&
    messageReceived.length == 0
  ) {
    toast(ToastMessage, 'error', toastOptions);
    setMessageReceived('seen');
  }

  return <></>;
};
